import { validateTemplateSnapshot } from '@/editor/core/component-template'
import { imageCatalogs } from './image-resources'

export function templateResult (response) {
  const data = response && response.data
  if (!data || data.success === false || (data.status !== undefined && data.status !== 200)) throw new Error(data && data.message || '模板返回格式不正确')
  return data.result === undefined ? data : data.result
}
export const templateCatalogs = imageCatalogs
export function normalizeTemplate (item) {
  if (!item || typeof item.id !== 'string' || !/^[A-Za-z0-9_-]{1,64}$/.test(item.id) || !['component', 'page', 'project'].includes(item.kind) ||
      !Number.isSafeInteger(item.version) || item.version < 1 || !Number.isSafeInteger(item.revision) || item.revision < 1 ||
      typeof item.name !== 'string' || !item.name.trim() || !Array.isArray(item.catalogIds) || !item.catalogIds.length ||
      item.catalogIds.some(id => typeof id !== 'string' || !/^[A-Za-z0-9_-]{1,64}$/.test(id))) throw new Error('模板返回格式不正确')
  const visibility = item.visibility === undefined ? 'private' : item.visibility
  if (!['private', 'public'].includes(visibility)) throw new Error('模板可见范围不正确')
  const snapshot = validateTemplateSnapshot(item.snapshot)
  if (snapshot.kind !== item.kind) throw new Error('模板类型与快照不一致')
  const coverFileId = item.coverFileId == null ? null : item.coverFileId
  if (coverFileId !== null && (typeof coverFileId !== 'string' || !/^[A-Za-z0-9_-]{1,64}$/.test(coverFileId))) throw new Error('封面文件ID无效')
  return { ...(item.resourceType === 'component' ? { resourceType: 'component' } : {}), ...(coverFileId ? { coverFileId } : {}), id: item.id, name: item.name.slice(0, 128), description: String(item.description || '').slice(0, 1000),
    kind: item.kind, visibility, version: item.version, revision: item.revision, editable: item.editable === true,
    catalogIds: item.catalogIds.slice(), snapshot }
}
export function templatePage (response) {
  const page = templateResult(response)
  if (!page || !Array.isArray(page.data) || !Number.isInteger(page.total) || page.total < 0 || !Number.isInteger(page.pageIndex) || page.pageIndex < 0 ||
      !Number.isInteger(page.pageSize) || page.pageSize < 1 || page.pageSize > 24 || page.data.length > page.pageSize || page.data.length > page.total) throw new Error('模板分页格式不正确')
  return { ...page, data: page.data.map(normalizeTemplate) }
}
export function savedTemplate (response, previous, expectedCoverFileId) {
  const item = normalizeTemplate(templateResult(response))
  if (expectedCoverFileId !== undefined && item.coverFileId !== expectedCoverFileId) throw new Error('封面保存结果未确认，请刷新资源列表检查')
  if (!item.editable || (previous && (item.kind !== previous.kind || item.id !== previous.id || item.revision !== previous.revision + 1 || item.version !== previous.version + 1))) throw new Error('保存结果未确认，请刷新模板列表检查')
  return item
}
// 三类模板均只恢复同一类型、同一模板的紧邻上一版，不接受客户端快照。
export function templateRestorePreview (response, id, kind) {
  const result = templateResult(response)
  const current = normalizeTemplate(result && result.current), previous = normalizeTemplate(result && result.previous)
  if (current.id !== id || previous.id !== id || current.kind !== previous.kind || (kind && current.kind !== kind) ||
      !current.editable || !previous.editable || current.version <= 1 || previous.version !== current.version - 1 ||
      !Number.isSafeInteger(current.version + 1) || !Number.isSafeInteger(current.revision + 1) ||
      previous.revision !== current.revision || previous.visibility !== current.visibility) throw new Error('恢复版本信息不一致，请关闭并刷新列表')
  return { current, previous }
}
export function restoredTemplate (response, preview) {
  const item = savedTemplate(response, preview.current), source = preview.previous
  if (item.coverFileId !== source.coverFileId || item.visibility !== preview.current.visibility || item.name !== source.name || item.description !== source.description ||
      JSON.stringify(item.catalogIds) !== JSON.stringify(source.catalogIds) || JSON.stringify(item.snapshot) !== JSON.stringify(source.snapshot)) throw new Error('恢复结果未确认，请关闭并刷新列表检查')
  return item
}
export function templateError (error) {
  const body = error && (error.data || (error.response && error.response.data))
  const detail = body && body.message
  if (typeof detail === 'string' && detail.trim()) return detail.trim()
  if (error && typeof error.message === 'string' && error.message.trim()) return error.message.trim()
  return error && error.status === 404 ? '模板或相关资源不存在，请刷新后重试' : '模板加载失败，请重试'
}
export function flattenTemplateCatalogs (tree, prefix = '') {
  return tree.flatMap(item => {
    const label = prefix ? prefix + ' / ' + item.name : item.name
    return [{ id: item.id, label }, ...flattenTemplateCatalogs(item.children, label)]
  })
}
